<template>
  <div class="customer">
    <div ref="contentTop">
      <div class="tool">
        <div class="customer-tool">
            <div></div>

            <div style="line-height: 40px">
              <!-- 新增 -->
              <AddEditDetail ref="drawer" :method="GetSearchList" :visible.sync="showAddEditDetail" />
              <!-- 新增 -->
              <el-button type="primary" class="hq-button" icon="el-icon-folder-add" @click="openAddEditDetail('add')">新增</el-button>
              <!-- 导出 -->
              <Export :pageParam="pageParam" :total="total" :searchParam="exportParams" />
              <!-- 职位档案-->
              <PositionProfile :visible.sync="showPositionProfileModal" />
            </div>
        </div>
      </div>
      <div
        :gutter="10"
        style="width: 94%; margin: 0 auto"
      >
          <Search
            :searchAllParam="searchAllParam"
            @search="handleSearch"
            @reset="reset"
            :searchParamList="searchParamList"
            code="count"
          />
      </div>
      <div class="line"></div>
    </div>
    <el-row style="width: 94%; margin: 0 auto">
      <el-col>
        <el-table
          highlight-current-row
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
          stripe
          size="mini"
          v-loading="listLoading"
          element-loading-text="拼命加载中"
          :row-style="{ height: '20px' }"
          :cell-style="{ padding: '0px' }"
          :header-cell-style="{ background: '#e5f2ff' }"
          @row-click="clickRow"
        >
          <el-table-column :show-overflow-tooltip="true"
          fixed
            label="审批编号"
            prop="id"
            width="170"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
          fixed
            label="成交校区"
            prop="subscribeSchoolName"
            width="150"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
          fixed
            label="校区属性"
            prop="schoolTypeName"
            width="80"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
          fixed
            label="学员订单号"
            prop="orderNo"
            width="160"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="学员姓名"
            prop="studentName"
            width="80"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="报读商品"
            prop="goodsName"
            width="160"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="就业次数"
            prop="employmentNum"
            width="75"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="学员就业时间"
            prop="employmentTime"
            width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="试用期月薪"
            prop="monthlyPay"
            width="90"
          ></el-table-column>
          
          <el-table-column :show-overflow-tooltip="true"
            label="就业老师"
            prop="employmentTeacher"
            width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="是否转正"
            prop="pass"
            width="75"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="转正时间"
            prop="passTime"
            width="90"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="转正月薪"
            prop="passPay"
            width="75"
          ></el-table-column>
          
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="性别"
            prop="sex"
            width="50"
          ></el-table-column> -->
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="学员手机号"
            prop="mobilePhone"
            width="120"
          >
            <template slot-scope="scope">
              <div class="phone" v-if="!!scope.row.mobilePhone">
                <span>{{ scope.row.seeShow ? scope.row.mobilePhone : scope.row.miphone  }}</span>
                <el-button @click.stop="seeShowClick(scope.row)" type="text" icon="el-icon-document-copy"></el-button>
              </div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="学员身份证号"
            prop="idcard"
            width="150"
          ></el-table-column> -->
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="学历"
            prop="educationName"
            width="60"
          ></el-table-column> -->
          
          <el-table-column :show-overflow-tooltip="true"
            label="面试职位"
            prop="interviewPosition"
            width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="就业企业"
            prop="employmentCompany"
            width="150"
          ></el-table-column>
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="就业城市"
            prop="employmentCtiy"
            width="100"
          ></el-table-column> -->
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="就业状态"
            prop="employmentState"
            width="80"
          ></el-table-column> -->
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="招生老师"
            prop="admissionsTeacher"
            width="100"
          ></el-table-column> -->
          <el-table-column :show-overflow-tooltip="true"
            label="备注"
            prop="remark"
            width="150"
          ></el-table-column>
          <!-- <el-table-column :show-overflow-tooltip="true"
            label="创建人"
            prop="createId"
            width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="创建时间"
            prop="createTime"
            width="150"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="更新人"
            prop="updateId"
            width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="更新时间"
            prop="updateTime"
            width="150"
          ></el-table-column> -->
          <el-table-column :show-overflow-tooltip="true"
            label="当前节点"
            prop="permission"
            min-width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="当前办理人"
            prop="approverName"
            min-width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="申请状态"
            prop="status"
            min-width="120"
          >
            <template slot-scope="scope">
              {{scope.row.status==5 ? '审批中' : (scope.row.status==1 ? '审批通过' : (scope.row.status==7 ? '审批中': (scope.row.status==2 ? '审批拒绝' : (scope.row.status==3 ? '审批撤销' : '')))) }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="提交人"
            prop="submitName"
            min-width="100"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true"
            label="提交时间"
            prop="submitTime"
            min-width="150"
          >
            <template v-slot:default="{ row }">
              <span v-if="row.submitTime!= '- -'">{{ row.submitTime | formatDate('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>- -</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop=""
            min-width="280"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- 空值或-1：未提交；5：已提交；1：审批结束；2驳回，3撤销  ,7：第一个人审批通过 -->
              <el-button type="text" @click="openAddEditDetail('detail',scope.row)">详情</el-button>  
              <el-button type="text" @click="changeJump(scope.row)">审核记录</el-button>
              <el-button type="danger"  class="hq-button" v-if="scope.row.makerId == myId" :disabled="scope.row.status==1 || scope.row.status==5 || scope.row.status==7 || scope.row.passType=='1'" @click="deleteClick(scope.row, 0)">删除</el-button>
              <el-button type="primary" class="hq-button" v-if="scope.row.makerId == myId" :disabled="isDisEdit(scope.row)" @click="openAddEditDetail('edit',scope.row)">编辑</el-button>
              <el-button type="success" class="hq-button" v-if="scope.row.makerId == myId" :disabled="scope.row.status==1 || scope.row.status==5 || scope.row.status==7" @click="submitBtn(scope.row, 0)">提交</el-button>
              <el-button type="primary" class="hq-button" @click="approvalShow(1,scope.row)"
                v-if="hasCheckPermission" :disabled="!scope.row.status || scope.row.status == -1 || scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3 || !canPass(scope.row)">
                通过
              </el-button>
              <el-button type="danger" class="hq-button" @click="approvalShow(2,scope.row)"
                v-if="hasCheckPermission" :disabled="!scope.row.status || scope.row.status == -1 || scope.row.status == 1 || scope.row.status == 2 || scope.row.status == 3 || !canPass(scope.row)">
                拒绝
              </el-button>
              <el-button class="hq-button" @click="listBtn(3,scope.row)"
                v-if="scope.row.makerId == myId" :disabled="!scope.row.status || scope.row.status == -1 || scope.row.status == 2 || scope.row.status == 3 || (!canRevoke(scope.row) && scope.row.status == 1)">
                撤销
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page_test_bottom">
          <el-pagination
            background
            @size-change="sizeChange"
            @current-change="currentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pageParam.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageParam.limit"
            :total="total"
          />
        </div>
      </el-col>
    </el-row>

    <HqModal :visible="approvalModel" :title="`是否${operationType==2?'拒绝':'通过'}`" width="400" @on-cancel="approvalCancel">
      <el-form ref="form" :model="form" :rules="formRules">
          <div>{{approvalStuName}} 学员的就业申请</div>
          <el-row :gutter="10">
              <div class="lineclass"></div>
              <el-col :span="24">
                  <el-form-item prop="changeReason">
                      <v-textarea
                          v-model="form.changeReason"
                          outlined
                          :min-height="80"
                          :placeholder="`请输入${operationType==2?'拒绝':'通过'}理由，200字内`"
                          name="input-7-4"
                          :label="`${operationType==2?'拒绝':'通过'}理由`"
                      ></v-textarea>
                  </el-form-item>
              </el-col>
          </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="approvalCancel">取消</el-button>
        <el-button @click="approvalOk" type="primary">确认</el-button>
      </div>
    </HqModal>

    <CheckHistory 
      :visible="onReviewHistoryStatus"
      :reviewData="reviewData"
      ref="drawerCheck"
      @on-cancel="onReviewHistoryCancel"
    />

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import common from '@/views/order/after-sale-nc/mixins/common'
import Export from "./components/studentEmployment/export";
import Search from "@/components/search";
import PositionProfile from "./components/studentEmployment/modelPositionProfile";
import AddEditDetail from "./components/studentEmployment/modelAddEditDetail";
import CheckHistory from "./components/studentEmployment/reviewHistory";
import { getEmploymentInformationList, employmentInformationUpdate } from "@/api/count";
import { formatTimes } from "@/utils/timeDate";
import { 
  getDeptList,
  getResTeachList,
 } from "api/public";
import {  getJudgetLookContack, doJiamiSeePhone } from "api/customer";
import Strhide from "@/utils/strhide";
import Crypto from "@/utils/crypto";
import axios from "axios";


export default {
  name: 'costmanagement',
  mixins: [common],
  components: {
    Search,
    PositionProfile,
    Export,
    AddEditDetail,
    CheckHistory
  },
  data() {
    const validateReason = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入变更理由'));
      } else {
        if (value.length > 200) {
          callback(new Error('变更理由输入长度不能大于200'));
        }
        callback();
      }
    };
    return {
      myId: '',
      showPositionProfileModal:false,// 打开职位档案开关
      showAddEditDetail: false,
      saveModel: false,
      searchAllParam: [
        // { 
        //   name: "createTime", 
        //   label: "创建时间", 
        //   type: "date", 
        //   value: [], 
        //   ref: "dealcreateTime", 
        //   show: false 
        // },
        {
          name: "subscribeSchoolIds",
          label: "成交校区",
          type: "multiTreeLabel",
          option: [],
          value: "",
        },
        { name: "orderNo", label: "订单号", type: "input", value: ""},
        // { name: "mobilePhone", label: "手机", type: "input", value: "" },
        { name: "studentName", label: "学员姓名", type: "input", value: ""},
        { 
          name: "employmentTime", 
          label: "学员就业时间", 
          type: "date", 
          value: [], 
          ref: "dealemploymentTime", 
          show: false 
        },
        // {
        //   name: "employmentNum",
        //   label: "就业次数",
        //   type: "select",
        //   option: [
        //     {name: "1", id: "1"},
        //     {name: "2", id: "2"}, 
        //     {name: "3", id: "3"},
        //     {name: "4", id: "4"},
        //     {name: "5", id: "5"},
        //   ],
        //   value: "",
        //   text: "name",
        //   id: "id",
        // },
        // {
        //   name: "employmentState",
        //   label: "就业状态",
        //   type: "select",
        //   option: [{name: "就业成功", id: "就业成功"}, {name: "培训中", id: "培训中"}, {name: "待业中", id: "待业中"}],
        //   value: "",
        //   text: "name",
        //   id: "id",
        // },
        {
          name: "employmentTeacherId",
          label: "就业老师",
          type: "select",
          value: "",
          option: [],
          text: "userName",
          id: "userName"
        },
        {
          name: "pass",
          label: "是否转正",
          type: "select",
          option: [{name: "是", id: '1'}, {name: "否", id: '0'}],
          value: "",
          text: "name",
          id: "id",
        },
        { 
          name: "passTime", 
          label: "转正时间", 
          type: "date", 
          value: [], 
          ref: "dealpassTime", 
          show: false 
        },
        {
          name: "status",
          label: "申请状态",
          type: "select",
          option: [
            {name: "审批通过", id: "1"},
            {name: "审批拒绝", id: "2"},
            {name: "审批撤销", id: "3"},
            {name: "审批中", id: "5"}],
          value: "",
          text: "name",
          id: "id",
        }, 
        {
          name: "schoolType",
          label: "校区属性",
          type: "dict",
          code: "DEPT_PROPERTY",
          value: "",
        },
        {
          name: "submitId",
          label: "提交人",
          type: "select",
          value: "",
          option: [],
          text: "userName",
          id: "userId"
        },
        { 
          name: "submitTime", 
          label: "提交时间", 
          type: "date", 
          value: [], 
          ref: "dealsubmitTime", 
          show: false 
        },
        // { 
        //   name: "approverId", 
        //   label: "审批人", 
        //   type: "select",
        //   value: "",
        //   option: [],
        //   text: "userName",
        //   id: "userName" 
        // },
      ],
      deptList:[], // 为了首次默认查询全部校区
      searchParamList: [],
      searchParam: {},
      exportParams: {},
      listLoading: false,
      tableData: [],
      pageParam: {
        page: 1,
        limit: 10
      },
      total: 0,
      // publicPath: process.env.BASE_URL,
      // fileList: [],   // excel文件列表

      reviewData: {},
      onReviewHistoryStatus: false,
      form: {
          changeReason: "",
      },
      formRules: {
        changeReason: [
          {required: true, validator: validateReason}
        ],
      },
      approvalModel: false,
      approvalId:'',
      approvalStuName: '',
      operationType: null,

      hasCheckPermission: false,
      currentTime: new Date(),
      isRoleStep1: false,
      isRoleStep2: false,
    }
  },
  methods: {
    // 复制号码
    seeShowClick(v) {
      let _this = this
      if(!v.seeShow) {
        v.seeShow = !v.seeShow
        this.$forceUpdate()
        
        this.$copyText(v.mobilePhone).then(function () {
          _this.$message.success("已复制号码")
          
        }, function () {
          _this.$message.error("抱歉，复制号码失败")
        })
      } else {
        v.seeShow = !v.seeShow
        this.$forceUpdate()
      }
    },
    // 获取一开始的下拉框来源
    async _getSearchAll() {
      this.searchAllParam.map((item) => {
        if(item.name == 'subscribeSchoolIds') {
          getDeptList().then(res => {
            item.option = res.result
            this.deptList = res.result
            // 把首次加载的查询列表放在获取部门后请求
            this.search()
          })
        }
      })
    },
    handleSearch() {
      this.pageParam.page = 1
      this.search()
    },
    // 查询btn
    search() {
      this.searchParam = {}
      this.searchAllParam.forEach( item => {
        if( (item.value !== undefined && item.value !== null && item.value !== '' ) || ( Array.isArray(item.value)  && item.value.length ) ) {
          if(item.type === "date") {
            if(item.name === "createTime" && item.value.length>0) {
              // console.log('item.value[0]', item.value[0]);
              this.searchParam.createStartTime = item.value[0] + ' 00:00:00';
              this.searchParam.createEndTime = item.value[1] + ' 23:59:59';
            }
            if(item.name === "submitTime" && item.value.length>0) {
              // console.log('item.value[0]', item.value[0]);
              this.searchParam.submitStartTime = item.value[0] + ' 00:00:00';
              this.searchParam.submitEndTime = item.value[1] + ' 23:59:59';
            }
            if(item.name === "employmentTime" && item.value.length>0) {
              // console.log('item.value[0]', item.value[0]);
              this.searchParam.employmentStartTime = item.value[0];
              this.searchParam.employmentEndTime = item.value[1];
            }
            if(item.name === "passTime" && item.value.length>0) {
              // console.log('item.value[0]', item.value[0]);
              this.searchParam.passStartTime = item.value[0];
              this.searchParam.passEndTime = item.value[1];
            }
          } else {
            this.searchParam[item.name] = item.value 
          }
        }
      })
      this.GetSearchList()
    },
    // 重置btn
    reset() {
      this.searchAllParam.map(item => {
        if(item.value || item.value == 0) {
          if(item.name === "createTime") {
            item.value = []
          } else {
            item.value = ""
          }
        }
      })
      this.pageParam = {
        page: 1,
        limit: 10,
      }
      this.total = 0
      this.search()
    },
    // 获取列表数据
    async GetSearchList() {
      let mydeptName = this.$store.state.user.loginUser.deptName
      let mydeptNameArr = []
      
      // console.log(this.searchParam.subscribeSchoolIds)
      if(this.searchParam.subscribeSchoolIds && this.searchParam.subscribeSchoolIds.length != 0){// 点击操作校区搜索框
        mydeptNameArr.push(...this.searchParam.subscribeSchoolIds)
      }else{// 默认搜索全部校区
        mydeptNameArr.push(mydeptName)
        let allDefaultDeptName = [];// 收集所有含children的部门名称
        // 定义递归遍历函数
        const traverse = (nodes) => {
          nodes.forEach(node => {
            allDefaultDeptName.push(node.deptName);
            // 检查是否存在children且不为空数组
            if (node.children && node.children.length > 0) {
              // 递归处理子节点
              traverse(node.children);
            }
          });
        };
        // 从根节点开始遍历
        traverse(this.deptList);
        mydeptNameArr.push(...allDefaultDeptName)
      }
      let params = {
        page: this.pageParam.page,
        limit: this.pageParam.limit,
        ...this.searchParam,
        subscribeSchoolIds: mydeptNameArr
      }

      this.exportParams = {
        ...this.searchParam,
        subscribeSchoolIds: mydeptNameArr
      }
      this.listLoading = true
      try{
        const { code, result, msg} = await getEmploymentInformationList(params)
        if (code == 0) {
          this.listLoading = false
          this.tableData = result.records || []
          this.tableData.map(item => {
            if(item.mobilePhone) {
              item.seeShow = false
              item.miphone = this.formatJiamiPhone(item.mobilePhone)
            }
          })
          this.total = result.total
        } else {
          this.$message.error(msg)
        }
      } finally{
        this.listLoading = false
      }
    },
    formatJiamiPhone(str) {
      const phone = String(str);
      if(phone.length==11){
        // 使用正则替换：捕获前3位和最后4位，中间的所有字符替换为4个星号
        return phone.replace(/^(.{3}).*(.{4})$/, '$1****$2');
      }else{
        return '';
      }
    },
    clickRow() {

    },
    sizeChange(val) {
      this.pageParam.limit = val;
      this.GetSearchList()
    },
    currentChange(val) {
      this.pageParam.page = val;
      this.GetSearchList()
    },
    // 删除
    deleteClick(val) {
      let params = {
        id: val.id,
        isExist: 1,
        updateId: this.$store.state.user.loginUser.userId,
        updateTime: formatTimes(new Date())
      }
      this.$hqMessageBox({
      message:
        `确认删除学员 ${val.studentName} 的就业信息？`,
      })
      .then(() => {
        return new Promise(async (resolve, reject) => { 
          const { code,  msg} = await employmentInformationUpdate(params)
          if (code == 0) {
            this.$message.success("删除成功！");
            this.search();
          } else {
            this.$message.warning(msg);
          }
        })
      })
      .catch(() => {
        console.log("取消");
      })
    },
    // 打开详情
    openAddEditDetail(status,row) {
      // this.showAddEditDetail = true;
      this.$refs.drawer.init(status,row)
    },
    // 审核详情
    changeJump(id) {
      console.log(id);
      this.reviewData = id
      this.$refs.drawerCheck.init(id)
    },
    onReviewHistoryCancel() {
      this.onReviewHistoryStatus = false;
    },
    async hasPermission(){
      const res = await axios.get(`/qw_school/schoolcj/order/api/employment/apply/checkPermission`,{
        headers:{
          "CrmToken": localStorage.getItem("userToken")
        }
      }).then((res) => res.data)
      console.log('res', res);
      if(res.code == 200) {
        if(res.data==='有权限操作'){
          this.hasCheckPermission = true
        }else{
          this.hasCheckPermission = false
        }
        // {"code":200,"data":"有权限操作","msg":"操作成功"}
      } else if(res.code == 500){
        this.hasCheckPermission = false
      }
    },
    // 提交
    submitBtn(val) {
      if(!val.photoUrl){
        this.$message.error('请重新编辑，需上传就业图片附件！');
        return
      }
      if(!val.monthlyPay){
        this.$message.error('请重新编辑，需填写试用期月薪！');
        return
      }
      if(val.pass == '是' && !val.passPay){
        this.$message.error('请重新编辑，需填写转正月薪！');
        return
      }
      let params = {
        id: val.id,
        dept: this.$store.state.user.loginUser.deptId,
      }
      this.$hqMessageBox({
      message:
        `确认提交学员 ${val.studentName} 的就业信息？`,
      })
      .then(() => {
        return new Promise(async (resolve, reject) => {
          const {code , msg} = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/submit`, params,{
            headers:{
              "CrmToken": localStorage.getItem("userToken")
            }
          }).then((res) => res.data)
          if (code == 200) {
            this.$message.success("提交成功！");
            this.search();
          } else {
            this.$message.warning(msg);
          }
        })
      })
      .catch(() => {
        console.log("取消");
      })
    },
    listBtn(status, row){
      let num = status
      let processInstanceId = row.id
      let studentName = row.studentName
      let str =''
      if(num == 1){
        str = "通过"
      }else if(num == 2){
        // str = "拒绝"
      }else if(num ==3){
        str = "撤销"
      }

      // if(row.status==5){// 如果是第一个人点击审批，点击前的状态为->1:已提交
      //   num = 7
      // }
      // if(row.status==7){// 如果是第二个人点击审批，点击前的状态为->7：审批通过
      //   num = 1
      // }
      this.$hqMessageBox({
        title: '提示',
        message: `是否${str}  ${studentName} 学员的就业统计申请?`
      }).then(async () => {
          const params = {
            operationType: num,
            processInstanceId: processInstanceId
          };
          this.listLoading = true
          const {code , msg} = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/approval`, params,{
            headers:{
              "CrmToken": localStorage.getItem("userToken")
            }
          }).then((res) => res.data)
          if (code === 200) {
            this.$message.success(msg);
            this.search();
          } else {
            this.$message.error(msg);
          }
      }).catch(() => {
        // reject(false);
      });
    },
    approvalCancel() {
      this.approvalModel = false
      this.form.changeReason = ""
      this.approvalId = ""
      setTimeout(() => {
        this.operationType = null
      }, 300);
      
    },
    approvalShow(status, data){
      this.approvalStuName = data.studentName
      this.approvalModel = true
      this.approvalId = data.id
    
      let num = status
      let str ='通过'
      if(num == 1){
        str = "通过"
        if(data.status==5){// 如果是第一个人点击审批，点击前的状态为->1:已提交
          num = 7
        }
        if(data.status==7){// 如果是第二个人点击审批，点击前的状态为->7：审批通过
          num = 1
        }
      }else if(num == 2){
        str = "拒绝"
      }
      // else if(num ==3){
      //   str = "撤销"
      // }
      this.operationType = num
    },
    async approvalOk() {
      if(this.operationType==2 && this.form.changeReason.length == 0) {
        return this.$message.error('请填写拒绝理由')
      }
      if(this.form.changeReason.length > 200) {
        return this.$message.error(`请保证${str}理由在200字以内`)
      }
      let params = {
        operationType: this.operationType,
        remark: this.form.changeReason,
        processInstanceId: this.approvalId
      }
      console.log('params', params);
      this.listLoading = true
      const res = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/approval`, params,{
        headers:{
          "CrmToken": localStorage.getItem("userToken")
        }
      }).then((res) => res.data)
      console.log('res,提交', res);
      if (res.code && res.code == 200) {
        this.$message.success(res.msg)
        this.approvalCancel()
        this.search();
      } else {
        this.$message.error(res.msg)
      }
    },
    // 判断是否可以撤销
    canRevoke(row) {
      const submitDate = new Date(row.submitTime);// 提交时间
      const applyDate = new Date(row.approverTime);//审批时间
      const currentTime = this.currentTime;// 当前时间
      // 比较年份和月份
      return submitDate.getFullYear() === applyDate.getFullYear() && submitDate.getFullYear() === currentTime.getFullYear() 
        && submitDate.getMonth() === applyDate.getMonth() && submitDate.getMonth() === currentTime.getMonth();
    },
    // 判断是否可以重新编辑转正后（即修改是否转正，编辑修改点击提交后首先先调用撤销api再更新保存api）
    isDisEdit(row) {
      if(row.status == 5 || row.status == 7){
        return true
      }
      // 审批通过+之前是否转正选择了否+就业时间（选了12月，然后1,2月这样是可以的），以上条件同时成立的话。
      if(row.status == 1){
        const isPass = row.pass == '否'
        const employmentTime = new Date(row.employmentTime);//就业时间
        const currentTime = this.currentTime;// 当前时间
        // 获取年份和月份
        const yearE = employmentTime.getFullYear();
        const monthE = employmentTime.getMonth();
        const yearC = currentTime.getFullYear();
        const monthC = currentTime.getMonth();
        const isTimeOK = (yearC > yearE) || (yearC === yearE && monthC > monthE);
        if(isPass && isTimeOK){
          return false
        }else{
          return true
        }
      }
      return false
    },
    // 判断角色是否可以审批
    canPass(row) {
      let pass = false
      if((row.status==5 || row.status==7) && this.isRoleStep1 && this.isRoleStep2){
        pass = true
      }else if(row.status==5 && this.isRoleStep1){// 就业校长审批
        pass = true
      }else if(row.status==7 && this.isRoleStep2){// 总就业审批
        pass = true
      }
      return pass
    },
  },
  computed: {
    ...mapGetters([
      "getTyUserInfo", "loginUser"
    ]),
    tableHeight() {
      return window.outerHeight - this.topHeight - 256 + 'px'
    },
    userInfo() {
      return this.$store.state.user.loginUser;
    },
  },
  mounted() {
    this.isRoleStep1 = this.userInfo.roleList.some(item => item.roleName == '就业校长审批')
    this.isRoleStep2 = this.userInfo.roleList.some(item => item.roleName == '总就业审批')
    this.myId = this.$store.state.user.loginUser.userId
    
    this.searchAllParam.map((item) => {
      if (item.name === "employmentTeacherId" || item.name === "submitId" || item.name === "approverId") {
        getResTeachList().then((data) => item.option = data.result);
      }
    });

    this.searchParamList = this.searchAllParam;
    this._getSearchAll()
    this.hasPermission()
    let _this = this
    // 每秒更新当前时间
    setInterval(() => {
      _this.currentTime = new Date();
    }, 1000)
    // setTimeout(function () {
    //   console.log('2025-09-03')
    //   _this.search()
    // }, 1000);
  }
}
</script>

<style lang="scss" scoped>
.lineclass {
  margin-top:20px;
  height: 10px;
  width: 100%;
  display: inline-block;
}
.customer {
  // padding-bottom: 40px;
  .titie {
    text-align: left;
  }

  .tool {
    background: #f5f7f9;
  }

  .customer-tool {
    display: flex;
    justify-content: space-between;
    width: 94%;
    margin: 0 auto;

    .tab-bar {
      overflow: hidden;

      .active {
        color: #409eff;
        position: relative;

        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 100%;
          height: 4px;
          background-color: #337aff;
          bottom: 0;
          left: 0;
        }
      }

      > span {
        float: left;
        margin-right: 12px;
        line-height: 40px;
        text-align: center;
        text-decoration: none;
        color: #000;
        cursor: pointer;
        font-size: 14px;
        padding: 0 10px;
      }
    }
  }
  .phone {
    .el-button--text {
      padding: 10px 4px;
    }
  }
}
::v-deep .action_col{
  padding: 4px 0 !important;
}
.action_btn{
  width: 60px;
  padding: 0;
  height: 24px;
  line-height: 24px;
  background-color: #337AFF;
  font-size: 13px;
  &.is-disabled{
    background-color: #E1E4EB;
    border-color: #E1E4EB;
  }
}
</style>
